import { Portal } from 'react-portal'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

import useDocumentTitle from '~/hooks/useDocumentTitle'

const NotFound = (): ReactElement => {
  useDocumentTitle('404')

  return (
    <Portal>
      <div className="error-boundary-container">
        <div className="error-boundary-fallback">
          <p className="sorry">Page not found :(</p>
          <p className="message">
            Refresh the page or return <Link to="/">home</Link>
          </p>
        </div>
      </div>
    </Portal>
  )
}

export default NotFound
